<template>
  <div>
    <van-contact-card
      v-if="show !== false"
      :type="cardType"
      add-text="添加就诊人"
      :name="contact.cardholderName"
      :tel="contact.cardholderContactPhone + '  就诊卡号：' + contact.cardNo"
      @click="onContactClick"
    />
  </div>
</template>

<script>
import { ContactCard, Dialog } from "vant";
import ContactPicker from "@/components/contact-picker";
import { cache } from "@/utils/common";

export default {
  components: {
    [ContactCard.name]: ContactCard,
  },
  props: {
    current: {
      type: Object,
      default() {
        return {};
      },
    },
    show: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  model: {
    prop: "current",
    event: "update",
  },
  computed: {
    cardType() {
      return this.contact && this.contact.id ? "edit" : "add";
    },
  },
  data() {
    return {
      contact: {},
      ContactPickerModal: "",
    };
  },
  created() {
    const contact = cache.get("currentContact");
    // if (contact) {
    //   this.contact = contact;
    //   this.$emit("update", this.contact);
    // } else {
    //获取联系人列表
    this.$post("Contact_List").then(res => {
      const list = res.data.datas;
      if (list && list.length) {
        if (contact && contact.id) {
          const index = list.findIndex(p => p.id === contact.id);
          if (index > -1) {
            this.contact = list[index];
          } else {
            this.contact = list[0];
          }
        } else {
          this.contact = list[0];
        }
        cache.set("currentContact", this.contact, 24 * 60 * 60 * 1000);
        this.$emit("update", this.contact);
      } else {
        this.contact = {};
        // this.$emit("update", this.contact);
        Dialog.confirm({
          title: "提示",
          message: "请先添加就诊人",
        })
          .then(() => {
            this.$router.push({
              name: "userContact",
            });
          })
          .catch(() => {
            this.$router.push({
              name: "index",
            });
          });
      }
    });
    // }
  },
  beforeDestroy() {
    this.ContactPickerModal && this.ContactPickerModal.cancel();
  },
  methods: {
    onContactClick() {
      if (this.contact && this.contact.id) {
        //选择就诊人
        this.ContactPickerModal = ContactPicker({
          value: this.contact.id,
          change: this.onContactChange,
        });
      } else {
        //新增就诊人
        this.$router.push({ name: "CreatCardMenu" });
      }
    },
    onContactChange(data) {
      this.contact = data;
      this.$emit("update", data);
      this.$emit("change", this.current);
    },
  },
};
</script>

<style></style>
